export default __webpack_public_path__ + "static/media/where-arrow-tablet.e795c678.svg";